import * as React from "react";
const SvgFiRrVideoconference = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-videoconference_svg__a)">
      <path
        fill="#062147"
        d="M22 18.172V12a1 1 0 0 0-2 0v6h-4.5a1 1 0 0 0-.707.293l-.707.707H9.914l-.707-.707A1 1 0 0 0 8.5 18H4v-7c0-1.654 1.346-3 3-3h4a1 1 0 0 0 0-2H7c-2.757 0-5 2.243-5 5v7.172A3 3 0 0 0 0 21c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3a3 3 0 0 0-2-2.828M21 22H3c-.551 0-1-.449-1-1s.449-1 1-1h5.086l.707.707A1 1 0 0 0 9.5 21h5c.265 0 .52-.105.707-.293l.707-.707H21c.551 0 1 .449 1 1s-.449 1-1 1m.048-22h-4.096A2.955 2.955 0 0 0 14 2.952v2.096a2.956 2.956 0 0 0 2.561 2.926l1.379 1.141c.292.26.659.388 1.021.388.354 0 .705-.123.977-.365l1.39-1.151A2.957 2.957 0 0 0 24 5.048V2.952A2.955 2.955 0 0 0 21.048 0M22 5.048a.953.953 0 0 1-.952.952h-.096a1 1 0 0 0-.638.23l-1.362 1.128-1.363-1.128a1 1 0 0 0-.638-.229.953.953 0 0 1-.952-.952V2.953c0-.525.427-.952.952-.952h4.096c.525 0 .952.427.952.952v2.096zM11.966 16.089q.034.106.034.21c-.002.373-.328.701-.742.701H6.743c-.491 0-.858-.46-.709-.911C6.434 14.877 7.611 14 9 14s2.566.878 2.966 2.089M9 13a2 2 0 1 1-.001-3.999A2 2 0 0 1 9 13m3 3.299q-.001-.104.034-.21C12.434 14.877 13.611 14 15 14s2.566.878 2.966 2.089c.149.451-.218.911-.709.911h-4.515c-.414 0-.74-.327-.742-.701M13 11a2 2 0 1 1 3.999-.001A2 2 0 0 1 13 11"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-videoconference_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrVideoconference;
